var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPolygon = function SvgPolygon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path829",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.5,
    d: "m3.5 7.446 6.163-4.12 7.266 2.247 3.745 8.165L15.5 20.5h-12z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "ellipse821",
    cx: 16.638,
    cy: 5.77,
    r: 2.5,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "path817",
    cx: 3.5,
    cy: 7.568,
    r: 2.5,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "ellipse819",
    cx: 9.746,
    cy: 3.748,
    r: 2.5,
    fill: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "ellipse823",
    cx: 20.308,
    cy: 13.56,
    r: 2.5,
    fill: "currentColor"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "ellipse825",
    cx: 15.814,
    cy: 20.5,
    r: 2.5,
    fill: "currentColor"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "ellipse827",
    cx: 3.5,
    cy: 20.5,
    r: 2.5,
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPolygon);
export default ForwardRef;